import { Component, OnInit } from '@angular/core';

import { PageInfoService } from '../../layouts/page-info.service';
import { NavSectionEnum } from '../../layouts/nav-section.enum';

@Component({
	selector: 'cc-report-home',
	templateUrl: './report-home.component.html',
	styleUrls: ['./report-home.component.css']
})
export class ReportHomeComponent implements OnInit {

// #region [ Constructor ]

	constructor(
		private _PageInfoService: PageInfoService
	) { }

// #region [ Implemented Methods ]

	ngOnInit() {
		this._PageInfoService.PageTitle = "Reporting";
		this._PageInfoService.PageDescription = "Coming Soon...";
		this._PageInfoService.CurrentSection = NavSectionEnum.Reports;
	}

}